<template>
  <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.2122 8.2376L7.66356 5.689L5.1142 8.2376M7.66356 16.3061L7.66356 5.6875"
      stroke="#FAFAFA"
      stroke-width="1.33929"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M12.3376 13.7622L14.8862 16.3107L17.4355 13.7622M14.8863 5.69403L14.8863 16.3127"
      stroke="#FAFAFA"
      stroke-width="1.33929"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
